import { hasKeysObjectUtil } from 'utils/object'
import { REDUX_STATUS } from '@gymaholic/packages'
import {
  ADDRESS_MODEL_CLASS_NAME,
  ADDRESS_MODEL_KEYS_REQUIRED
} from 'models/daos/address/constants'
import {
  EMAIL_TEMPLATE_MODEL_CLASS_NAME,
  EMAIL_TEMPLATE_MODEL_KEYS_REQUIRED
} from 'models/daos/email-template/constants'
import { getStatusReduxUtil } from 'modules/redux/utils/legacy/get-status'
import { isPointerReduxUtil } from 'modules/redux/utils/legacy/is-pointer'

/**
 * A mapping of ClassName to required attributes.
 * @type {Object}
 */
const MODEL_KEY_REQUIRED = {
  [ADDRESS_MODEL_CLASS_NAME]: ADDRESS_MODEL_KEYS_REQUIRED,
  [EMAIL_TEMPLATE_MODEL_CLASS_NAME]: EMAIL_TEMPLATE_MODEL_KEYS_REQUIRED
}

/**
 * Checks whether a instance is loaded.
 * @param  {Instance|null}  instance
 * @returns {boolean}
 */
function isLoadedReduxUtil (instance) {
  if (!instance) {
    return false
  }
  // Get the required attributes
  const attrs = MODEL_KEY_REQUIRED[instance.className]
  let hasRequiredAttrs = true
  if (attrs) {
    hasRequiredAttrs = hasKeysObjectUtil(instance.data, attrs)
  }
  return !!(
    (
      // If the instance is loaded
      // and
      // its required attributes (if any) are there, return true
      getStatusReduxUtil(instance) === REDUX_STATUS.SUCCESS && hasRequiredAttrs
    ) ||
    // If the instance is a pointer, return true
    isPointerReduxUtil(instance)
  )
}

export {
  isLoadedReduxUtil
}
